import React from 'react';
import photo from './photo.jpg';
import './App.css';

function App() {
    return (
        <div className="app">
            <header className="app-header">
                <div className="app-logo">
                    <img src={photo} alt="logo"/>
                </div>

                <h1 className={'app-full-name'}><p>ЕГОР</p>ЧЕРНЫШОВ</h1>

                <div className={'app-skills'}>
                    <p>software development</p>
                </div>

                <p className={'app-links'}>
                    <a href="https://t.me/jarogor">t.me/jarogor</a>
                </p>

            </header>
        </div>
    );
}

export default App;
